import { React, PropTypes, Layout, Icon, FelaComponent } from '../dependencies';
import Title from './Title';

const { Header: AntdHeader } = Layout;

const iconRule = ({ theme }) => ({
    background: 'transparent',
    padding: '0 20px',

    '@media (min-width: 768px)': {
        padding: '0 25px',
    },

    '& .anticon-setting': {
        float: 'left',
        fontSize: '30px',
        color: theme.colors.black,
        cursor: 'pointer',
    },
});

const Header = ({ onOpenPanel }) => (
    <FelaComponent
        rule={iconRule}
        render={({ className }) => (
            <AntdHeader className={className}>
                <Icon type="setting" theme="filled" onClick={onOpenPanel} />
                <Title />
            </AntdHeader>
        )}
    />
);

Header.propTypes = {
    onOpenPanel: PropTypes.func.isRequired,
};

export default Header;
